// Story 12.4 — Pure logic helper extracted from EvolutionConnectionPanel
// to enable testing without jsdom or React imports. AC #11: the panel is
// invisible for any bot whose `whatsapp.provider` is not 'evolution-go'.

interface BotConfigShape {
  whatsapp?: {
    provider?: 'cloud-api' | 'evolution-go';
  };
}

export function shouldShowEvolutionPanel(
  botConfig: Record<string, unknown> | null | undefined,
): boolean {
  const provider = (botConfig as BotConfigShape | undefined)?.whatsapp?.provider ?? 'cloud-api';
  return provider === 'evolution-go';
}
